// Author YuJiaBei
// Date 2021-01-05 08:33:12

class RepairSpecializedType {
constructor({
        id = null,
        name = '',
        description = ''}
= {}) {
    this.id = id;
    this.name = name;
    this.description = description;
}
}

function newEntity() {
return new RepairSpecializedType();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'name',
        label: 'label.em.repair.repairSpecializedType.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'description',
        label: 'label.em.repair.repairSpecializedType.grid.description',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        }
    ])}

const filter = {
    nameFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'nameFilter',
        label: 'label.em.repair.repairSpecializedType.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'name',
        label: 'label.em.repair.repairSpecializedType.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'description',
        label: 'label.em.repair.repairSpecializedType.entity.description',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        }
]

export {RepairSpecializedType, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
